export const tipoPrecificacaoCampanha = {
    MANUAL: "Manual",
    FAIXAS: "Faixas",
};